import { gql } from "@apollo/client";

const GET_INVOICES = gql`
  query GetInvoices {
    me {
      invoices {
        id
        billingDate
        url
      }
    }
  }
`;

export default GET_INVOICES;
